import React, { useState, useEffect } from 'react';
import styles from '../../styles/OnboardingScreen.module.css';

// Rotating value propositions for welcome screen
const VALUE_PROPS = [
  'Build your emergency fund',
  'Start investing confidently',
  'Save for your goals',
  'Plan for retirement',
  'Grow your wealth wisely'
];

function IntroScreen({ title, description, onNext, onBack, introId }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentPropIndex, setCurrentPropIndex] = useState(0);

  // Check if this is the welcome intro screen
  const isWelcomeScreen = introId === 'welcome-intro';

  // Check if this intro has a hero image
  const isMissionIntro = introId === 'mission-intro';
  const isContactIntro = introId === 'contact-intro';
  const hasHeroImage = isWelcomeScreen || isMissionIntro || isContactIntro;

  // Rotate value props every 3 seconds for welcome screen
  useEffect(() => {
    if (!isWelcomeScreen) return;

    const interval = setInterval(() => {
      setCurrentPropIndex((prev) => (prev + 1) % VALUE_PROPS.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [isWelcomeScreen]);

  const handleNext = async () => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      await onNext();
      setIsSubmitting(false);
    }
  };

  // Construct image URL based on environment
  const getImageUrl = (filename) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    if (apiUrl) {
      return `${apiUrl}/onboarding/${filename}`;
    }
    return `/onboarding/${filename}`;
  };

  // Get hero image filename based on intro screen type
  const getHeroImageFilename = () => {
    if (isWelcomeScreen) return 'hero-welcome.png';
    if (isMissionIntro) return 'hero-define-goal.png';
    if (isContactIntro) return 'hero-optimize-experience.png';
    return null;
  };

  return (
    <div className={styles.introContent}>
      {/* Hero image header for intro screens */}
      {hasHeroImage && (
        <div className={styles.welcomeHeader}>
          <img
            src={getImageUrl(getHeroImageFilename())}
            alt={title}
            className={styles.welcomeHeroImage}
          />
        </div>
      )}

      <div className={styles.topSection}>
      </div>

      <div className={styles.introMiddleSection}>
        <div>
          <h1 className={styles.title}>{title}</h1>

          {isWelcomeScreen ? (
            <>
              <p className={styles.tagline}>
                Your AI-powered money coach helping you build financial freedom
              </p>
              <p className={styles.description}>
                Let's get to know you better, so we can provide you with a personalised investment coaching experience.
              </p>

              {/* Rotating value props */}
              <div className={styles.valuePropContainer}>
                <div className={styles.valueProp} key={currentPropIndex}>
                  {VALUE_PROPS[currentPropIndex]}
                </div>
              </div>
            </>
          ) : (
            <p className={`${styles.description} ${styles.introDescription}`}>{description}</p>
          )}
        </div>
      </div>

      <div className={styles.bottomSection}>
        <div className={styles.buttonGroup}>
          {onBack && (
            <button
              className={`${styles.button} ${styles.buttonSecondary}`}
              onClick={onBack}
              disabled={isSubmitting}
            >
              Back
            </button>
          )}
          <button
            className={`${styles.button} ${styles.buttonPrimary} ${isWelcomeScreen ? styles.buttonPrimaryLarge : ''}`}
            onClick={handleNext}
            disabled={isSubmitting}
          >
            {isWelcomeScreen ? 'Get Started' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default IntroScreen;
